import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PhoneIcon from '@material-ui/icons/Phone';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { toast } from 'react-toastify';
import {
    linkTel, linkWhatsApp, linkLinkedin, linkEmail, formatarTelefone, copiarTexto,
} from '../utils/contato';

const COR = '#4B8B33';
const estiloBotao = { padding: 4 };
const parar = (e) => e.stopPropagation(); // não abrir o card/linha ao clicar no ícone

function Botao({ titulo, href, novaAba, onClick, children, id }) {
    return (
        <Tooltip title={titulo}>
            <IconButton
                size="small"
                style={{ ...estiloBotao, color: COR }}
                component={href ? 'a' : 'button'}
                href={href || undefined}
                target={novaAba ? '_blank' : undefined}
                rel={novaAba ? 'noopener noreferrer' : undefined}
                onMouseDown={parar}
                onClick={(e) => { parar(e); onClick && onClick(e); }}
                aria-label={titulo}
                data-testid={id}
            >
                {children}
            </IconButton>
        </Tooltip>
    );
}

async function copiar(texto, rotulo) {
    const ok = await copiarTexto(texto);
    if (ok) toast.success(`${rotulo} copiado`, { autoClose: 1500 });
    else toast.error(`Não foi possível copiar o ${rotulo.toLowerCase()}`);
}

/**
 * Ações de contato em um clique.
 * props: telefone, email, linkedin, nome (usado na mensagem do WhatsApp), mostrarNumero (exibe o número formatado)
 */
export default function ContatoRapido({ telefone, email, linkedin, mostrarNumero = true, mensagem, quebrarLinha = true }) {
    const tel = linkTel(telefone);
    const wa = linkWhatsApp(telefone, mensagem);
    const li = linkLinkedin(linkedin);
    const mail = linkEmail(email);

    if (!telefone && !email && !linkedin) return null;

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: quebrarLinha ? 'wrap' : 'nowrap', gap: 2 }} onMouseDown={parar}>
            {mostrarNumero && telefone && (
                <span style={{ marginRight: 4 }}>{formatarTelefone(telefone)}</span>
            )}
            {tel && (
                <Botao titulo="Ligar" href={tel} id="contato-ligar"><PhoneIcon fontSize="small" /></Botao>
            )}
            {wa && (
                <Botao titulo="WhatsApp" href={wa} novaAba id="contato-whatsapp"><WhatsAppIcon fontSize="small" /></Botao>
            )}
            {telefone && (
                <Botao titulo="Copiar telefone" onClick={() => copiar(formatarTelefone(telefone), 'Telefone')} id="contato-copiar-telefone">
                    <FileCopyOutlinedIcon fontSize="small" />
                </Botao>
            )}
            {mail && (
                <Botao titulo={`E-mail: ${email}`} href={mail} id="contato-email"><MailOutlineIcon fontSize="small" /></Botao>
            )}
            {email && (
                <Botao titulo="Copiar e-mail" onClick={() => copiar(email, 'E-mail')} id="contato-copiar-email">
                    <FileCopyOutlinedIcon fontSize="small" style={{ opacity: 0.7 }} />
                </Botao>
            )}
            {li && (
                <Botao titulo="Abrir LinkedIn" href={li} novaAba id="contato-linkedin"><LinkedInIcon fontSize="small" /></Botao>
            )}
        </span>
    );
}
